
<style>
  .frame::-webkit-scrollbar {
    -webkit-appearance: none;
  }

    .frame::-webkit-scrollbar:vertical {
      width: 11px;
    }

    .frame::-webkit-scrollbar:horizontal {
      height: 11px;
    }

  .frame::-webkit-scrollbar-thumb {
    border-radius: 8px;
    border: 2px solid white; /* should match background, can't be transparent */
    background-color: rgba(0, 0, 0, .5);
  }

  .frame::-webkit-scrollbar-track {
    background-color: #fff;
    border-radius: 8px;
  }

  /*No footer in dialog fix */
  mat-dialog-content {
    overflow: initial !important;
  }

  .mat-dialog-container {
    height: auto !important;
  }

  .errormessage {
    color: red;
    font-size: 80%;
    font-style: italic;
  }

  .warning-box {
    border: 1px solid red;
    background-color: #ffe5e5; /* Light red background */
    padding: 20px;
    margin: 10px auto 20px auto;
    font-weight: bold;
  }

  .salary-receiver-title {
    margin: 0 0 20px;
    color: #111827;
    font-size: 20px;
    font-weight: 700;
  }

  .salary-receiver-form {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 16px;
  }

  .salary-field-wide,
  .salary-form-message {
    grid-column: 1 / -1;
  }

  .field-help {
    margin: -10px 0 0;
    color: #59657b;
    font-size: 11px;
    line-height: 1.35;
  }

  .self-managed-message {
    margin: 0 0 16px;
    padding: 14px 16px;
    border: 1px solid #dfe4ec;
    border-radius: 7px;
    background: #fbfcfe;
    color: #59657b;
    font-size: 13px;
    line-height: 1.5;
  }

  .salary-field {
    display: block;
    width: 100%;
  }

  .resolved-bank {
    display: flex;
    align-items: baseline;
    gap: 6px;
    color: #59657b;
    font-size: 13px;
  }

  .resolved-bank strong {
    color: #111827;
    font-size: 14px;
    font-weight: 700;
  }

  :host ::ng-deep .salary-field .mat-form-field-wrapper {
    margin: 0;
    padding-bottom: 0;
  }

  :host ::ng-deep .salary-field .mat-form-field-flex,
  :host ::ng-deep .salary-field .mat-mdc-text-field-wrapper {
    min-height: 56px;
    align-items: center;
    padding: 0 12px !important;
    border: 1px solid #dfe4ec;
    border-radius: 7px;
    background: var(--sam-input-background, #f7f7f7);
    box-sizing: border-box;
  }

  :host ::ng-deep .salary-field .mat-form-field-infix,
  :host ::ng-deep .salary-field .mat-mdc-form-field-infix {
    min-height: 56px;
    padding: 20px 0 6px;
    border-top: 0;
    box-sizing: border-box;
  }

  :host ::ng-deep .salary-field .mat-form-field-underline,
  :host ::ng-deep .salary-field .mdc-line-ripple,
  :host ::ng-deep .salary-field .mat-mdc-form-field-focus-overlay {
    display: none;
  }

  .salary-receiver-actions {
    display: flex;
    justify-content: flex-end;
    gap: 8px;
    margin-top: 24px;
  }

  .salary-receiver-actions button {
    min-width: 120px;
    height: 44px;
    margin: 0;
    padding: 0 18px;
    border-radius: 999px;
    box-shadow: 0 3px 10px rgba(20, 36, 63, 0.1);
    font-size: 14px;
    font-weight: 600;
  }

  .salary-receiver-actions button:disabled {
    box-shadow: none;
  }

  @media (max-width: 639px) {
    .salary-receiver-form {
      grid-template-columns: minmax(0, 1fr);
    }

    .salary-field-wide,
    .salary-form-message {
      grid-column: auto;
    }
  }
</style>

<h2 mat-dialog-title class="salary-receiver-title" *ngIf="isNewUser">Ny lönemottagare</h2>
<h2 mat-dialog-title class="salary-receiver-title" *ngIf="!isNewUser">Redigera användare</h2>

<p *ngIf="pNrValid && user.HasLoggedIn" class="self-managed-message">
  Denna medarbetare har loggat in på sitt konto och administrerar det därför själv.
</p>

<div *ngIf="personalNumberError" style="color:red;margin-bottom:15px;">{{personalNumberError}}</div>

<form #personForm="ngForm" class="salary-receiver-form" novalidate>
  <!-- Personnummer -->
  <mat-form-field floatLabel="always" appearance="fill" class="salary-field salary-field-wide">
    <mat-label>Personnummer</mat-label>
    <input matInput type="text"
           (ngModelChange)="pNumberValidCheck($event)"
           [(ngModel)]='user.PersonalNumber'
           [disabled]="!isNewUser"
           placeholder="ÅÅÅÅMMDDNNNN (12 siffror utan bindestreck)"
           required
           name="Personnummer">
    <mat-icon *ngIf="!pNrValid && isNewUser" color="accent" matSuffix matTooltipPosition="before" matTooltip="Personen ej verifierad" style="color:red;">close</mat-icon>
  </mat-form-field>

  <span *ngIf="!pNrValid" class="errormessage salary-form-message">{{errorMessagePnr}}</span>

  <mat-form-field floatLabel="always" appearance="fill" class="salary-field" *ngIf="pNrValid">
    <mat-label>Förnamn</mat-label>
    <input matInput type="text" [disabled]="true" ngModel [(ngModel)]='user.FirstName' name="firstname">
  </mat-form-field>

  <mat-form-field floatLabel="always" appearance="fill" class="salary-field" *ngIf="pNrValid">
    <mat-label>Efternamn</mat-label>
    <input matInput type="text" [disabled]="true" ngModel [(ngModel)]='user.LastName' name="lastname">
  </mat-form-field>

  <mat-form-field floatLabel="always" appearance="fill" class="salary-field salary-field-wide" *ngIf="pNrValid && !userExistsInTenant && !user.HasLoggedIn">
    <mat-label>E-post</mat-label>
    <input matInput type="email" #correctEmail="ngModel" [(ngModel)]="user.Email" name="Email" required email>
    <mat-icon *ngIf="correctEmail.invalid && correctEmail.touched" matSuffix color="accent">warning</mat-icon>
  </mat-form-field>

  <mat-form-field floatLabel="always" appearance="fill" class="salary-field salary-field-wide" *ngIf="pNrValid && !userExistsInTenant && !user.HasLoggedIn">
    <mat-label>Typ av bankuppgift</mat-label>
    <mat-select [(ngModel)]="bankEntryMode" (ngModelChange)="onBankEntryModeChange($event)" name="bankEntryMode">
      <mat-option value="swedish">Svensk bank</mat-option>
      <mat-option value="personkonto">Nordea personkonto</mat-option>
      <mat-option value="international">Utländsk bank</mat-option>
    </mat-select>
  </mat-form-field>

  <div class="resolved-bank salary-field-wide" *ngIf="pNrValid && !userExistsInTenant && !user.HasLoggedIn && user.BankName">
    <span>Bank</span>
    <strong>{{ user.BankName }}</strong>
  </div>

  <mat-form-field floatLabel="always" appearance="fill" class="salary-field" *ngIf="pNrValid && !userExistsInTenant && !user.HasLoggedIn && bankEntryMode === 'international'">
    <mat-label>BIC</mat-label>
    <input matInput type="text" [(ngModel)]="user.Bic" name="Bic" required>
  </mat-form-field>

  <mat-form-field floatLabel="always" appearance="fill" class="salary-field" *ngIf="pNrValid && !userExistsInTenant && !user.HasLoggedIn && bankEntryMode === 'international'">
    <mat-label>IBAN</mat-label>
    <input matInput type="text" [(ngModel)]="user.Iban" name="Iban" required>
  </mat-form-field>

  <span class="field-help salary-field-wide" *ngIf="pNrValid && !userExistsInTenant && !user.HasLoggedIn && bankEntryMode === 'international'">
    BIC: 8 eller 11 tecken; de första 6 ska vara bokstäver. IBAN: 15–34 tecken, inlett med landskod och två kontrollsiffror.
  </span>

  <mat-form-field floatLabel="always" appearance="fill" class="salary-field" *ngIf="pNrValid && !userExistsInTenant && !user.HasLoggedIn && bankEntryMode === 'swedish'">
    <mat-label>Clearingnummer</mat-label>
    <input matInput type="text" [ngModel]="user.ClearingNumber" (ngModelChange)="onClearingNumberChange($event)" name="clearing" required>
  </mat-form-field>

  <mat-form-field floatLabel="always" appearance="fill" class="salary-field" [class.salary-field-wide]="bankEntryMode === 'personkonto'" *ngIf="pNrValid && !userExistsInTenant && !user.HasLoggedIn && bankEntryMode !== 'international'">
    <mat-label>Bankkontonummer</mat-label>
    <input matInput type="text" [ngModel]="user.AccountNumber" (ngModelChange)="onAccountNumberChange($event)" [readonly]="bankEntryMode === 'personkonto'" name="AccountNumber" required>
  </mat-form-field>

  <span class="field-help salary-field-wide" *ngIf="pNrValid && !userExistsInTenant && !user.HasLoggedIn && bankEntryMode === 'swedish' && user.Bank">
    Clearingnummer: {{ user.Bank.ClearingNumberValidationErrorText }}<br>
    Kontonummer: {{ user.Bank.AccountNumberValidationErrorText }}
  </span>

  <span class="field-help salary-field-wide" *ngIf="pNrValid && !userExistsInTenant && !user.HasLoggedIn && bankEntryMode === 'personkonto' && user.Bank">
    Kontonumret ska motsvara personnumrets sista 10 siffror.
  </span>

  <span *ngIf="bankValidationError" class="errormessage salary-form-message">{{bankValidationError}}</span>

  <!--<mat-form-field style="width: 100%;">
    <mat-select [(ngModel)]="user.RoleIds"
                placeholder="Role"
                (ngModelChange)="user.RoleIds = $event"
                name="roles"
                #roleSelect="ngModel"
                multiple>
      <mat-option *ngFor="let role of roles" [value]="role.Id">{{role.Name}}</mat-option>
    </mat-select>
  </mat-form-field>-->

</form>

<div>{{errorMessage}}</div>

<div *ngIf="userExistsInTenant" style="margin-top: 15px;">
  Spara för att koppla till medarbetarlistan.
</div>

<button *ngIf="user.HasLoggedIn == null || !user.HasLoggedIn" mat-raised-button style="float: right;margin-top:15px;" color="accent"
        [disabled]="!personForm.valid || (!pNrValid && isNewUser) || (correctEmail != null && !correctEmail.valid) || !validateBankInfo(false)"
        (click)="save(user)">
  <mat-icon>check</mat-icon>
  &nbsp;Spara&nbsp;
</button>&nbsp;

